import defaultTranslate from "./es.js"
import adretailTranslate from "./es_adretail.js"
import casaideasTranslate from "./es_casaideas.js"

const getTranslate = (word, fileTranslated) => {
  if (fileTranslated.hasOwnProperty(word)) {
    return fileTranslated[word]
  } else {
    return defaultTranslate[word] || word
  }
}

const _translate = (word) => {
  let website = window.$website
  switch (website) {
    case "adretail":
      return getTranslate(word, adretailTranslate)
    case "casaideas":
      return getTranslate(word, casaideasTranslate)
    case "sandbox":
      return getTranslate(word, casaideasTranslate)
    default:
      return getTranslate(word, casaideasTranslate)
  }
}

export default _translate
